// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"ad5bfc2b","administration":"47dc88ab","src_main_webapp_app_shared_util_donor-collect_ts":"53f97c29"}[chunkId] + ".chunk.js";
};